import { ApiError } from '@/api/client';
function normalized(value, nullable) {
    if (typeof value !== 'string')
        return value;
    const trimmed = value.trim();
    return nullable && trimmed === '' ? null : trimmed;
}
export function buildChangedPatch(base, draft, nullableKeys = []) {
    const nullable = new Set(nullableKeys);
    const patch = {};
    for (const key of Object.keys(draft)) {
        const next = normalized(draft[key], nullable.has(key));
        const previous = normalized(base[key], nullable.has(key));
        if (!Object.is(next, previous))
            patch[key] = next;
    }
    return patch;
}
export function requiredTextError(value) {
    return value.trim() ? null : 'Это поле нельзя очистить';
}
export function locationFieldErrors(error, allowed) {
    if (!(error instanceof ApiError) || error.status !== 422)
        return {};
    const detail = error.body?.detail;
    if (!Array.isArray(detail))
        return {};
    const allowedFields = new Set(allowed);
    const result = {};
    for (const issue of detail) {
        if (!issue || typeof issue !== 'object')
            continue;
        const loc = issue.loc;
        const msg = issue.msg;
        const field = Array.isArray(loc) ? loc.at(-1) : null;
        if (typeof field !== 'string' || typeof msg !== 'string' || !allowedFields.has(field))
            continue;
        result[field] = msg.replace(/^Value error,\s*/u, '');
    }
    return result;
}
export function locationObjectAction(isActive, usersCount) {
    if (isActive)
        return 'hide';
    return usersCount > 0 ? 'unassign' : 'delete';
}
function pluralUsers(value) {
    const mod100 = value % 100;
    const mod10 = value % 10;
    if (mod100 >= 11 && mod100 <= 14)
        return 'пользователей';
    if (mod10 === 1)
        return 'пользователь';
    if (mod10 >= 2 && mod10 <= 4)
        return 'пользователя';
    return 'пользователей';
}
export function locationAdminError(error, fallback = 'Не удалось выполнить запрос.') {
    if (!(error instanceof ApiError))
        return fallback;
    const detail = error.body?.detail;
    if (error.status === 409 && detail && typeof detail === 'object' && !Array.isArray(detail)) {
        const conflict = detail;
        const code = typeof conflict.error === 'string' ? conflict.error : '';
        const users = typeof conflict.users_count === 'number' && Number.isFinite(conflict.users_count)
            ? conflict.users_count
            : 0;
        if (code === 'delete_requires_hidden' || code === 'unassign_requires_hidden') {
            return 'Сначала скройте запись.';
        }
        if (code === 'delete_has_users') {
            return `К записи привязано ${users} ${pluralUsers(users)}. Снимите пользователей и повторите.`;
        }
        if (code === 'no_default_option_for_users') {
            return `Некуда переназначить ${users} ${pluralUsers(users)}. Включите активную опцию с флагом «Назначать новым» и повторите.`;
        }
        if (code === 'unassign_in_progress')
            return 'Снятие пользователей уже выполняется.';
        if (code === 'group_in_use') {
            return 'Группа используется локациями. Сначала перенесите их в другую группу или уберите группу.';
        }
        return fallback;
    }
    if (error.status === 400 && typeof detail === 'string') {
        if (detail === 'Этот сквад уже привязан к данной опции')
            return 'Сквад уже привязан.';
        if (detail === 'Сквад уже привязан к опции локации') {
            return 'Этот сквад уже привязан к опции.';
        }
        if (detail === 'Указанная опция или сквад не найдены') {
            return 'Опция или сквад не найдены.';
        }
        return fallback;
    }
    if (error.status === 404)
        return 'Запись не найдена.';
    if (error.status === 403)
        return 'Недостаточно прав.';
    if (error.status === 503) {
        return 'Сервис авторизации временно недоступен, повторите позже.';
    }
    return fallback;
}
export function locationConfirmationError(error) {
    return `Не удалось подтвердить сохранение. ${locationAdminError(error, 'Повторите попытку.')}`;
}
